import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import {
  frontendBeforeSend,
  frontendIgnoreErrors,
} from './sentry-filters-frontend';

export function sentrySetup() {
  const dsn = process.env.MIX_SENTRY_DSN_FRONTEND;

  if (!dsn) return;

  const release = process.env.RELEASE;

  Sentry.init({
    dsn,
    release,
    integrations: [
      //
      new Integrations.BrowserTracing(),
    ],

    // Lower the sample rate for production to not exceed our quota
    tracesSampleRate: 0.01,
    debug: false,
    ignoreErrors: frontendIgnoreErrors,
    beforeSend: frontendBeforeSend,
  });
}
